export default "__VITE_ASSET__CaWKhsUY__"